// TODO IMPROVEMENT: Modify backend response for camelCase

export interface IShare {
  id: number;
  companyName: string;
}

export class Share implements IShare {
  constructor(
    public id: number,
    public companyName: string,
  ) {}
}
